import { makeAutoObservable, observable } from 'mobx';

import type { ClassifyDraftNode } from '@/api/ai-knowledge/types';

/** 知识库来源选项类型 */
export interface AiKbSourceOption {
  label: string;
  value: number;
}

/**
 * AI知识库绑定类型枚举
 */
export enum AiKbBindTypeEnum {
  /** 未绑定 */
  None = 0,
  /** 智能分类 */
  IntelTag = 1,
  /** 用户自定义分类 */
  LevelId = 3,
}

type AiKnowledgeBaseState = {
  kbSourceOptions: AiKbSourceOption[];
  kbIntelOptions: IClassOption[];
  kbBindType: AiKbBindTypeEnum | null;
  kbBindId: string;
  refreshKBList: number;
  refreshCorpusTable: number;
  refreshKBDetail: number;
  refreshClassifyTree: number;
  /** 智能分类详情页 - 分类树数据 */
  classifyTreeData: ClassifyDraftNode[];
};

export type AiKnowledgeBaseStateKeys = keyof AiKnowledgeBaseState;

/** AI知识库相关信息 STORE */
class AiKnowledgeBaseStore {
  @observable public kbSourceOptions: AiKbSourceOption[] = [];
  @observable public kbIntelOptions: IClassOption[] = [];
  @observable public kbBindType: AiKbBindTypeEnum = AiKbBindTypeEnum.None;
  @observable public kbBindId: string = '';
  /** 刷新知识库列表 */
  @observable public refreshKBList = 0;
  /** 刷新语料表格 */
  @observable public refreshCorpusTable = 0;
  /** 刷新知识库详情 */
  @observable public refreshKBDetail = 0;
  /** 刷新分类树 */
  @observable public refreshClassifyTree = 0;
  /** 智能分类详情页 - 分类树数据 */
  @observable public classifyTreeData: ClassifyDraftNode[] = [];

  public constructor() {
    makeAutoObservable(this);
  }

  /** 通用设置方法 */
  public setState<K extends AiKnowledgeBaseStateKeys>(key: K, value: this[K]) {
    this[key] = value;
  }

  /** 批量设置方法 */
  public setStates<K extends keyof AiKnowledgeBaseState>(
    states: Pick<AiKnowledgeBaseState, K>
  ) {
    Object.entries(states).forEach(([key, value]) => {
      this.setState(key as K, value as this[K]);
    });
  }

  /**
   * 更新AI知识库绑定信息
   * 将kbBindType重置为None，kbBindId重置为空字符串
   */
  public async handleUpdateAiKnowledgeBaseConfig() {
    // await queryAiKnowledgeBaseConfig({ appId: store.appId }).then((res) => {
    //   this.setStates({
    //     kbBindType: res?.type || AiKbBindTypeEnum.None,
    //     kbBindId: res?.id,
    //   });
    // });
  }

  /** 刷新知识库列表 */
  public setRefreshKBList() {
    this.setState('refreshKBList', Date.now());
  }
  /** 刷新语料表格 */
  public setRefreshCorpusTable() {
    this.setState('refreshCorpusTable', Date.now());
  }
  /** 刷新知识库详情 */
  public setRefreshKBDetail() {
    this.setState('refreshKBDetail', Date.now());
  }
  /** 刷新分类树 */
  public setRefreshClassifyTree() {
    this.setState('refreshClassifyTree', Date.now());
  }
}

/** AI知识库信息 STORE */
const AI_KNOWLEDGE_BASE_STORE = new AiKnowledgeBaseStore();

export type TAiKnowledgeBaseStore = typeof AI_KNOWLEDGE_BASE_STORE;

export default AI_KNOWLEDGE_BASE_STORE;
